import React, { useState } from 'react';
import { 
    Button, 
    Modal, 
    Input, 
    Space, 
    Typography, 
    message,
    Form,
    Select,
    Divider,
    notification,
    Spin
} from 'antd';
import { 
    PlusOutlined, 
    EditOutlined, 
    DeleteOutlined
} from '@ant-design/icons';
import { AddOrUpdateLocation, DeleteLocation } from '../redux/LicenseManager/saga';
import { LoadingOutlined } from '@ant-design/icons';


const { Option } = Select;
const { Text } = Typography;

const LocationManager = ({ 
    locationList = [], 
    onLocationListChange, 
    placeholder = "Select Location",
    style = {},
    value,
    onChange,
    disabled = false,
    loading = false
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [newLocation, setNewLocation] = useState('');
    const [editLocation, setEditLocation] = useState('');
    const [editIndex, setEditIndex] = useState(-1);
    const [isEditLoading, setIsEditLoading] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);


   // / Add "No Location" option at the top
    // const allLocations = [
    //     { Location_Name: "No Location", id: },
    //     ...locationList
    // ];

    const showModal = () => {
        setIsModalVisible(true);
        setNewLocation('');
    };

    const handleAddLocation = async () => {
        if (newLocation.trim()) {

            const isLocationExists = locationList.find(item => item.Location_Name === newLocation.trim())
            if (isLocationExists) {
                notification.warning({
                    message: 'Location already exists!',
                });

                return;
            }
            setIsAddLoading(true);
            const payload = [{
                Location_Name: newLocation.trim(),
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
            }]

        // const locationList = ['Bahia Spd 1',
        //     'Bahia Spd 7',
        //     'Bahia Spd 8',
        //     'Bintan',
        //     'Blackfin',
        //     'fdf',
        //     'Houston-Bay',
        //     'Houston-Lab',
        //     'Katy',
        //     'Kintore',
        //     'Kintore Bay 8',
        //     'KSA',
        //     'LAB',
        //     'Sempra',
        //     'TULSA',
        //     'Westfield India',
        //     'Zeewolde']

        //     const payloadList = locationList.map(item => ({
        //         Location_Name: item,
        //         createdAt: new Date().toISOString(),
        //         updatedAt: new Date().toISOString()
        //     }))

                const response = await AddOrUpdateLocation(payload,'Location')
          //  console.log('response', response)   
            if(response && response.length > 0){
            const updatedList = [...locationList, { Location_Name: newLocation.trim(), id: response[0].id, createdAt: response[0].createdAt, updatedAt: response[0].updatedAt }];
            onLocationListChange(updatedList);
            setNewLocation('');
            setIsModalVisible(false);
            notification.success({
                message: 'Location added successfully!',
              });
            }   
            else{
                notification.error({
                    message: 'Location add failed!',
                  });
            }
        } else {
            notification.error({
                message: 'Please enter a valid location name',
              });
        }
        setIsAddLoading(false);
    };

    const handleEditLocation = async () => {
        if (editLocation.trim() && editIndex >= 0) {
            setIsEditLoading(true);
            const payload = {
                Location_Name: editLocation.trim(),
                id: locationList[editIndex].id,
                createdAt: locationList[editIndex].createdAt || new Date().toISOString(),
                updatedAt: new Date().toISOString()
            }
          //  console.log('payload', payload)
            const response = await AddOrUpdateLocation(payload,'Location')
          //  console.log('response', response)   
            if(response){
            const updatedList = [...locationList];
            updatedList[editIndex] = { 
                Location_Name: editLocation.trim(),
                id: locationList[editIndex].id,
                createdAt: locationList[editIndex].createdAt || new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };
            onLocationListChange(updatedList);
                setEditLocation('');
                setEditIndex(-1);
                setIsEditModalVisible(false);
            notification.success({
                message: 'Location updated successfully!',
              });
            }
            else{

                notification.error({
                    message: 'Location update failed!',
                  });
            }
           
        } else {
            notification.error('Please enter a valid location name');
        }
        setIsEditLoading(false);
        };

    const handleDeleteLocation = async (index) => {
        const payload = {
            id: locationList[index].id
        }
        const response = await DeleteLocation(payload,'Location')      
        if(response){
            const updatedList = locationList.filter((_, i) => i !== index);
            onLocationListChange(updatedList);
            notification.success({
                message: 'Location deleted successfully!',
              });
        }
        else{
            notification.error({
                message: 'Location delete failed!',
              });
        }
    };

    const showEditModal = (location, index) => {
        setEditLocation(location);
        setEditIndex(index);
        setIsEditModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setNewLocation('');
    };

    const handleEditCancel = () => {
        setIsEditModalVisible(false);
        setEditLocation('');
        setEditIndex(-1);
    };

    return (
        <div>
            <Select
                placeholder={placeholder}
                className='client-select'
                style={style}
                value={value}
                onChange={onChange}
                disabled={disabled}
                showSearch
                allowClear
                dropdownRender={menu => (
                    <>
                        {menu}
                        <Divider style={{ margin: '5px 0', borderTop: '1px solid lightgrey' }} />
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'center', 
                            padding: '8px',
                            width: '100%'
                        }}>
                            <Button 
                                type="primary" 
                                icon={<PlusOutlined />} 
                                onClick={showModal}
                                style={{ width: '100%', textAlign: 'center', borderRadius: '15px' }}
                            >
                                Add New Location
                            </Button>
                        </div>
                    </>
                )}
            >
                {loading && <Spin indicator={<LoadingOutlined spin />} />}
                {locationList && locationList
                    .sort((a, b) => {
                        // "No Location" should always be first
                        if (a.Location_Name === "No Location") return -1;
                        if (b.Location_Name === "No Location") return 1;
                        // Then sort alphabetically
                        return a.Location_Name.localeCompare(b.Location_Name);
                    })
                    .map((item, index) => (
                    <Option key={item.id} value={item.Location_Name}>
                        <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            width: '100%'
                        }}>
                            <span>{item.Location_Name}</span>
                            {item.Location_Name !== "No Location" && (
                            <EditOutlined
                               // className='edit_dropdown_list_icon'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    showEditModal(item.Location_Name, index);
                                }}
                                //style={{ color: '#FFFFFF' }}
                            />
                            )}
                        </div>
                    </Option>
                ))}
            </Select>

            {/* Add Location Modal */}
            <Modal
                className='client-modal'
                title="Add New Location"
                visible={isModalVisible}
                      
                            
                footer={[
                    <div style={{ paddingTop: '20px', paddingRight: '10px' }} className='pipeline-btn'>
                        <Button key="cancel"
                            onClick={handleCancel}
                        >
                        Cancel
                        </Button>   
                        <Button key="submit" type="primary"
                            onClick={handleAddLocation}
                            loading={isAddLoading}
                            style={{
                                backgroundColor: !newLocation.trim() ? "gray" : "#ef314c",
                            }}
                        >
                            Add 
                        </Button>
                    </div>
                ]}
               
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Location Name"
                        required
                        rules={[{ required: true, message: 'Please enter location name!' }]}
                    >
                        <Input
                            placeholder="Enter location name"
                            value={newLocation}
                            onChange={(e) => setNewLocation(e.target.value)}
                            onPressEnter={handleAddLocation}
                            autoFocus
                            size='large'
                            className='client-input'
                        />
                    </Form.Item>
                </Form>
            </Modal>

            {/* Edit Location Modal */}
            <Modal
                title="Edit Location"
                className='client-modal'
                visible={isEditModalVisible}
                onOk={handleEditLocation}
                onCancel={handleEditCancel}
                footer={[
                    <div style={{ paddingTop: '20px', paddingRight: '10px' }} className='pipeline-btn'>
                        <Button key="cancel"
                            onClick={handleEditCancel}
                        >
                            Cancel
                        </Button>   
                        <Button key="submit" type="primary"
                            onClick={handleEditLocation}
                            loading={isEditLoading}
                            style={{
                                backgroundColor: !editLocation.trim() ? "gray" : "#ef314c",
                            }}
                        >
                            Update
                        </Button>
                    </div>
                ]}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Location Name"
                        required
                        rules={[{ required: true, message: 'Please enter location name!' }]}
                    >
                        <Input
                            placeholder="Enter location name"
                            value={editLocation}
                            onChange={(e) => setEditLocation(e.target.value)}
                            onPressEnter={handleEditLocation}
                            autoFocus
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default LocationManager;
